import { render, staticRenderFns } from "./Skelton.vue?vue&type=template&id=7ad9c1f2&scoped=true"
var script = {}
import style0 from "./Skelton.vue?vue&type=style&index=0&id=7ad9c1f2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad9c1f2",
  null
  
)

export default component.exports